/**
 * Narrowest the chat pane gets beside the docked artifact panel. Its own
 * module so the admission shell's reserved split doesn't import the chat
 * presentation tree (and next/image with it) just for the number.
 */
export const DOCKED_CHAT_PANE_MIN_WIDTH = 420;
